import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import {
  Root,
  Hero,
  HeroImageContainer,
  HeroContent,
  Title,
} from './InSalonClasses.style';

import seminarImageSrc from '../../../assets/images/education/request_a_class.jpg';

import { TwoColumnSection } from '../../../components/TwoColumnSection/TwoColumnSection';
import { EducationBlock } from '../../../components/EducationBlock/EducationBlock';

export const InSalonClasses = () => {
  const intl = useIntl();

  return (
    <Root>
      <Hero>
        <HeroImageContainer />
        <HeroContent>
          <Title>
            <FormattedMessage defaultMessage="In-Salon Classes" />
          </Title>
        </HeroContent>
      </Hero>

      <TwoColumnSection
        imageSrc={seminarImageSrc}
        title={intl.formatMessage({
          defaultMessage: 'Take your skills to the next level',
        })}
        desc={
          <span>
            <p>
              <FormattedMessage defaultMessage="Looking to boost your in-salon product knowledge or take your skills to the next level with hands-on support from one of our talented brand specialists?" />
            </p>
            <br />
            <p>
              <FormattedMessage defaultMessage="We're here to help you grow with personalized education tailored to your needs." />
            </p>
          </span>
        }
        ctaText={intl.formatMessage({ defaultMessage: 'REQUEST A CLASS' })}
        ctaUrl="/education/request"
        accentColor="#9457a3"
      />

      <EducationBlock excludePage="in-salon-classes" />
    </Root>
  );
};
